import React from "react";
import "./banner.style.sass";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button } from "rsuite";
import SingleNews from "../../pages/singleNews/singleNews.page";
import { withRouter, Route, Link } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { selectApplication } from "../../redux/site/site.selector";
import { Setting } from "../../setting";

class BannersComponent extends React.Component {
	render() {
		const { history, application } = this.props;
		console.log(this.props);
		const settings = {
			dots: true,
			pauseOnFocus: true,
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			rtl: true,
		};

		return (
			<div className={`banners-main usage-main`}>
				{console.log(settings)}
				<Route
					path={`${history.pathname}/:id`}
					component={SingleNews}
				/>
				<div className="banners-content">
					<Slider {...settings}>
						{application
							? application?.map((item, i) => (
									<>
										<img
											src={`${Setting.apiUrl}/${item.img}`}
											alt="xitonix-news"
											className="news-banner-img"
											key={i}
										/>
										<img
											src={`${Setting.apiUrl}/${item?.img_mobile}`}
											alt="xitonix-news"
											className="news-banner-mobile-img"
											key={i}
										/>
									</>
							  ))
							: ""}
					</Slider>
				</div>
			</div>
		);
	}
}
const mapStateToProps = createStructuredSelector({
	application: selectApplication,
});

export default withRouter(connect(mapStateToProps)(BannersComponent));
